<section class="auth-action-shell">
  <div class="card">
    <p class="eyebrow">Compte</p>
    <h1>Définir un nouveau mot de passe</h1>

    <p class="lead" *ngIf="checkingToken">Vérification du lien en cours…</p>

    <ng-container *ngIf="!checkingToken && !successMessage && canResetPassword">
      <p class="lead">
        Saisissez un nouveau mot de passe pour votre compte, puis validez.
      </p>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <label>
          <span>Nouveau mot de passe</span>
          <input type="password" formControlName="password" placeholder="••••••••" />
        </label>

        <label>
          <span>Confirmer le mot de passe</span>
          <input type="password" formControlName="confirmPassword" placeholder="••••••••" />
        </label>

        <button type="submit" [disabled]="submitting">
          {{ submitting ? 'Mise à jour…' : 'Mettre à jour le mot de passe' }}
        </button>
      </form>
    </ng-container>

    <p class="success" *ngIf="successMessage">{{ successMessage }}</p>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <p class="redirect-note" *ngIf="successMessage && isAndroidDevice">
      Si l’application est installée et liée au domaine, utilisez le bouton ci-dessous pour
      revenir dans AfriFood.
    </p>

    <div class="actions">
      <a *ngIf="successMessage" [href]="openAppUrl">Ouvrir l’application</a>
      <a [href]="playStoreUrl" target="_blank" rel="noopener">Télécharger l’application</a>
      <a routerLink="/">Retour à l’accueil</a>
    </div>
  </div>
</section>
